var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisaLight = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 24"
}), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 24,
  fill: "#fff",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#172B85",
  fillRule: "evenodd",
  d: "M12.143 16.29H9.72L7.903 9.467c-.086-.313-.27-.591-.539-.722a8 8 0 0 0-2.221-.722V7.76h3.904c.538 0 .942.395 1.01.853l.942 4.923 2.422-5.776h2.356zm4.981 0h-2.288l1.884-8.53h2.289zm4.846-6.167c.067-.46.471-.723.942-.723a4.3 4.3 0 0 1 2.222.394l.404-1.837a5.9 5.9 0 0 0-2.087-.394c-2.221 0-3.837 1.181-3.837 2.821 0 1.248 1.145 1.903 1.953 2.298.874.393 1.21.656 1.143 1.05 0 .59-.673.853-1.345.853-.808 0-1.617-.197-2.356-.526l-.404 1.838c.808.328 1.682.46 2.49.46 2.49.064 4.039-1.116 4.039-2.888 0-2.232-3.164-2.362-3.164-3.346m11.173 6.168-1.817-8.532h-1.952c-.404 0-.808.263-.943.657l-3.365 7.875h2.356l.47-1.247h2.895l.27 1.247zm-3.432-6.234.672 3.215h-1.884z",
  clipRule: "evenodd"
})));
export default SvgVisaLight;